// extracted by mini-css-extract-plugin
export var actionText = "_nd-4";
export var container = "_nd-0";
export var leftSection = "_nd-1";
export var rightSection = "_nd-2";
export var settingsButton = "_nd-6";
export var settingsIcon = "_nd-7";
export var shortcut = "_nd-5";
export var shortcutGroup = "_nd-3";